// @ts-nocheck
import { BNPL_ORDER_PREFIX } from "./constants/bnpl";
import { EncryptedClaimObject } from "./type";
import { generateJwe, generateJwt, Signing } from "@credify/crypto";
import { FiatCurrency } from "@credify/api-docs/apiClients/integration-v2/model";
import { Duration } from "@credify/api-docs/apiClients/types/apiClients/integration-v2";
import { Phone } from "@credify/api-docs/apiClients/v2/model";
export { camelize, decamelize } from "@credify/crypto";
import { apiBase } from "./config";
import { Mode } from "../types";
import { ConfigurationParameters, Configuration } from "@credify/api-docs/apiClients/v2";

const CURRENCY_VALUES = ["USD", "VND", "JPY"];
const DURATION_UNIT = ["UNKNOWN", "DAY", "MONTH", "YEAR"];

const isArray = (a: any): boolean => {
  return Array.isArray(a);
};

const isObject = (o: any): boolean => {
  return o === Object(o) && !isArray(o) && typeof o !== "function";
};

export const aggregateClaims = async (claimObject: any, publicKey: string, signing: Signing): Promise<EncryptedClaimObject> => {
  const result: EncryptedClaimObject = {
    _claim_names: {},
    _claim_sources: {},
  }

  const scopeNames = Object.keys(claimObject);
  for await (const scopeName of scopeNames) {
    Object.keys(claimObject[scopeName]).forEach((claimName) => {
      result._claim_names[claimName] = scopeName;
    })
    const jwt = generateJwt(signing, claimObject[scopeName])
    const jwe = await generateJwe(jwt, publicKey)
    if (jwe) {
      result._claim_sources[scopeName] = {
        JWT: jwe
      }
    }
  }

  return result;
}

export const convertJsonValueToString = (o: any): any => {
  if (isObject(o)) {
    const n = {};
    Object.keys(o).forEach((k) => {
      if (typeof o[k] !== "object") {
        // @ts-ignore
        n[k] = `${o[k]}`;
      } else {
        // @ts-ignore
        n[k] = convertJsonValueToString(o[k]);
      }
    });
    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return convertJsonValueToString(i);
    });
  }

  return o;
};

export const isObjectNullOrEmpty = (obj: any) => {
  return obj === null || Object.keys(obj).length === 0;
};

export const trimObject = (o: any) => {
  if (isObject(o)) {
    const trimmed = {};
    Object.keys(o).forEach((k) => {
      if (typeof o[k] !== "object") {
        // @ts-ignore
        trimmed[k] = o[k].replace(/\"/g, "");
      } else {
        // @ts-ignore
        trimmed[k] = trimObject(o[k]);
      }
    });
    return trimmed;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return trimObject(i);
    });
  }

  return o;
};

export const validateFiatCurrencyObject = (amount?: FiatCurrency | null) => {
  let c = {} as FiatCurrency;
  if (amount && amount.currency) {
    if (CURRENCY_VALUES.includes(amount.currency)) {
      if (amount.value && !isNaN(amount.value)) {
        c = {
          currency: amount.currency,
          value: amount.value.toString(),
        } as FiatCurrency;
      } else {
        throw new Error("The value needs to be a number");
      }
    } else {
      throw new Error(
        `The currency needs to be one of ${CURRENCY_VALUES.join(", ")}`
      );
    }
  }
  return c;
};

export const validatePhoneNumber = (phone?: Phone) => {
  const p = {} as Phone
  if (phone?.phoneNumber) {
    const number = phone.phoneNumber.startsWith("0")
      ? phone?.phoneNumber.substring(1)
      : phone?.phoneNumber
    p.phoneNumber = number
  }

  if (phone?.countryCode) {
    const countryCode = phone.countryCode.startsWith("+")
      ? phone?.countryCode
      : `+${phone?.countryCode}`
    p.countryCode = countryCode
  }

  return p
}

export const validateDurationObject = (duration?: Duration | null) => {
  let c = undefined;
  if (duration && duration.unit) {
    if (DURATION_UNIT.includes(duration.unit)) {
      if (duration.value && !isNaN(duration.value)) {
        c = {
          unit: duration.unit,
          value: duration.value,
        } as Duration;
      }
    } else {
      throw new Error(
        `The unit needs to be one of ${DURATION_UNIT.join(", ")}`
      );
    }
  }
  return c;
};

export const validateDisbursementClaimKey = (claimKey: string) => {
  if (claimKey.split(":").length !== 3) {
    return false;
  }

  if (claimKey.split(":")[0] !== BNPL_ORDER_PREFIX) {
    return false;
  }

  return true;
};

let configParam = undefined

export const handleAPIConfiguration = (mode: Mode) => {
  if (configParam) {
    return configParam
  }
  const configParameters: ConfigurationParameters = {
    basePath: apiBase(mode)
  };
  configParam = new Configuration(configParameters);
  return configParam;
}